export default __webpack_public_path__ + "static/265-bf991ccebaac079cefd28f3e162478d6.gif";